module.exports = __webpack_public_path__ + "static/media/video.446380a0.svg";